import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Paper,
  Tooltip,
  FormHelperText,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

// CONSTANTS
import { FundsPaymentType } from '@/constants/streamingRewards';

// STYLES
import StripeCardFields from '@/components/Payment/StripeCardFields';

function CreditCardForm({
  isChange,
  onCancelChangeCard,
  setFieldTouched,
  setFieldValue,
  values,
  errors,
  touched,
}) {
  const [t] = useTranslation();

  const saveError = errors?.save;

  return (
    <Paper className="credit-card-form">
      <StripeCardFields
        name="cardFields"
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
        values={values}
        touched={touched}
        errors={errors}
      />
      <FormControl
        required={values.type === FundsPaymentType.MONTHLY}
        error={Boolean(saveError)}
        className="m-t-20 credit-card-form__save"
      >
        <div className="save">
          <FormControlLabel
            className={clsx('save__label', saveError && 'save__label--error')}
            value={FundsPaymentType.ONE_TIME}
            control={
              <Checkbox
                name="save"
                color="primary"
                checked={Boolean(values?.save)}
                onChange={({ target: { name, checked } }) => setFieldValue(name, checked)}
                onBlur={({ target }) => {
                  setFieldTouched(target.name, true, false);
                }}
              />
            }
            label={<span className="p5">{t('streamingRewardsFunds.saveCard')}</span>}
          />
          <Tooltip
            title={<p className="p4">{t('streamingRewardsFunds.saveInfo')}</p>}
            placement="top"
          >
            <InfoIcon className="info-icon" />
          </Tooltip>
        </div>
        <FormHelperText>{saveError}</FormHelperText>
      </FormControl>
      {isChange && (
        <Button
          variant="text"
          size="small"
          className="cancel-change-btn"
          onClick={onCancelChangeCard}
        >
          {t('buttons.cancel')}
        </Button>
      )}
    </Paper>
  );
}

CreditCardForm.propTypes = {
  isChange: PropTypes.bool.isRequired,
  onCancelChangeCard: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};

export default React.memo(CreditCardForm);
